<template>
  <!-- <HelloWorld msg="Welcome to Your Vue.js App" /> -->
  <RouterView />
  <LoaderSpinner></LoaderSpinner>
</template>

<script>
import LoaderSpinner from './components/LoaderSpinner.vue'
import { RouterView } from 'vue-router'

export default {
  name: 'App',
  components: {
    LoaderSpinner,
    RouterView
  }
}
</script>

<style scoped>

</style>
